import { render, staticRenderFns } from "./75Enrollments.vue?vue&type=template&id=8069aa08&"
import script from "./75Enrollments.vue?vue&type=script&lang=js&"
export * from "./75Enrollments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports